/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useEffect, useState} from "react";
import {useLocation, Route, Switch} from "react-router-dom";
import MenuNavbar from "../components/Navbars/MenuNavbar";
import HeaderNavBar from "../components/Navbars/HeaderNavBar";
import routes from "routes.js";
import WithDashboardWrapper from "../components/WithDashboardWrapper";
import NotFound from "../views/404";
import constants from "../constants";
import * as authSelectors from "../selectors/auth";
import {useDispatch, useSelector} from "react-redux";
import PAGE from "../utils/Destination";
import {useHistory} from "react-router";
import {retrieveToken} from "../utils/StorageManager";
import _ from "lodash";
import PaymentLayout from "../layouts/Payment.js";
import {useQuery} from "@tanstack/react-query";
import * as axiosInstance from "../services/axiosInstance";
import Helper from "../utils/Helper";
import ClientInfo from "../views/Dashboard/components/ClientInfo";
import NotificationMessage from "../utils/NotificationMessage";
import ProfileLayout from "./ProfileLayout";
import EIPOLayout from "./EIPOLayout";

function Dashboard(dashboardProps) {
    const location = useLocation();
    const history = useHistory();
    const mainPanel = React.useRef(null);
    const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
    const profile = useSelector((state) => state?.user);
    const dispatch = useDispatch();
    const locationPath = _.get(history, ["location", "pathname"], "");
    const [isCheck, setIsCheck] = useState(false);

    useQuery({
        queryKey: ["checking"],
        queryFn: async ({queryKey}) => {
            try {
                return await axiosInstance.get(`/clientarea/profile/check`);
            } catch (e) {
                Helper.handleHttpError(e, dispatch);
            }
        },
        refetchOnWindowFocus: true,
        refetchInterval: 10000,
        enabled: isCheck
    });

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === "ta-token") {
                const requestToken = event.newValue;
                if (requestToken !== null) {
                    setIsCheck(true)

                } else {
                    setIsCheck(false)
                }
            }
        };

        retrieveToken(constants.AUTH_TOKEN).then((token) => {
            if (!_.isEmpty(token)) {
                setIsCheck(true)
            } else {
                setIsCheck(false)

            }
        });

        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    useEffect(() => {
        checkLogout(isLogout);
    }, [isLogout]);

    async function checkLogout(isLogout) {
        const token = await retrieveToken(constants.AUTH_TOKEN);
        if (isLogout && _.isEmpty(token)) {
            history.push(PAGE.LOGIN);
        }
    }

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (_.includes(prop.path, "/dashboard/payment") || _.includes(prop.path, '/dashboard/profile')) {
                return;
            }
            return (
                <Route
                    exact
                    path={`${prop.path}`}
                    render={(props) => <prop.component {...dashboardProps} {...props} />}
                    key={key}
                />
            );
        });
    };

    React.useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainPanel.current.scrollTop = 0;
        if (
            window.innerWidth < 993 &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
            var element = document.getElementById("bodyClick");
            element.parentNode.removeChild(element);
        }
    }, [location]);

    const isShowClientInfo = () => {
        const locationPath = _.get(history, ["location", "pathname"], "");
        const targetRoutes = _.find(
            routes,
            _.matchesProperty("path", locationPath),
        );
        if (!_.isEmpty(targetRoutes)) {
            return _.get(targetRoutes, ["isShowClientInfo"], false);
        }
        return false;
    };
    const showClientHeader = isShowClientInfo() || true;

    return (
        <>
            <div className="wrapper">
                <div className="main-panel" ref={mainPanel}>
                    <HeaderNavBar/>
                    <MenuNavbar/>

                    <div className="float-header-container">
                        {showClientHeader ? (
                            <ClientInfo
                                isDashboard={locationPath === "/dashboard"}
                                item={profile}
                            ></ClientInfo>
                        ) : (
                            false
                        )}
                    </div>

                    <div className="content content-bg position-relative">
                        <Switch>
                            {getRoutes(routes)}
                            <Route
                                path="/dashboard/payment"
                                render={(props) => (
                                    <PaymentLayout {...dashboardProps} {...props} />
                                )}
                            />
                            <Route
                                path="/dashboard/profile"
                                render={(props) => (
                                    <ProfileLayout profileData={profile} {...dashboardProps} {...props} />
                                )}
                            />
                            <Route
                                path="/dashboard/e-ipo"
                                render={(props) => (
                                    <EIPOLayout {...props} />
                                )}
                            ></Route>

                            <Route path={`*`} component={NotFound} key="not-found"/>
                        </Switch>
                    </div>
                    {/*<Footer />*/}
                </div>
            </div>
        </>
    );
}

export default WithDashboardWrapper(Dashboard);
